// frontend/src/utils/index.js

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Utility function for merging class names
export const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};

// Format currency as USD
export const formatCurrency = (amount) => {
  if (!amount) return 'N/A';
  
  // If amount is already a string (like a range), return it as is
  if (typeof amount === 'string') {
    return amount;
  }
  
  // Otherwise format as currency
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

// Format date from ISO string
export const formatDate = (isoString) => {
  if (!isoString) return '';
  
  const date = new Date(isoString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

// Extract error message from API response
export const getErrorMessage = (error) => {
  return error.response?.data?.message || 
    error.message || 
    'An unexpected error occurred';
};

// Truncate text with ellipsis
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  
  return text.slice(0, maxLength) + '...';
};

// Get initials from name
export const getInitials = (name) => {
  if (!name) return '';
  
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase();
};

// Simple email validation
export const isValidEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Check if a value is empty (null, undefined, empty string, or empty array)
export const isEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && value.trim() === '') return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === 'object' && Object.keys(value).length === 0) return true;
  return false;
};